<h2 class="rss-title">{{ 'blog.title' | translate }}</h2>
<div
	class="blog"
	*ngIf="feed$ | async as feed; else placeholder"
	[class.horizontal]="!isMobile"
	[class.span]="!isMobile && feed.length === maxPosts"
>
	<obg-post
		*ngFor="let post of feed; let i = index; trackBy: trackByPost"
		[post]="post"
		[ngClass]="!isMobile && (i === 0 || feed.length <= 2) ? 'featured' : 'list'"
		[class.single]="feed.length === 1"
	></obg-post>
</div>
<ng-template #placeholder>
	<div class="blog" [class.horizontal]="!isMobile" [class.span]="!isMobile">
		<obg-post
			*ngFor="let placeholder of placeholders; let i = index"
			class="placeholder"
			[ngClass]="!isMobile && (placeholders.length === maxPosts && i === 0) ? 'featured' : 'list'"
		></obg-post>
	</div>
</ng-template>
<p *ngIf="!isMobile">{{ 'blog.subtitle' | translate }}</p>
<a class="blog-cta" [class.mat-button]="!isMobile" [obgRouteLink]="{url: 'blog.cta.url' | translate}"
	>{{ 'blog.cta' | translate }}</a
>
